import React, { useState } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { AddReferralModalV2 } from '../../../../modals/AddReferralModalV2/AddReferralModalV2';
import { RefreshEvents } from '../../../../../../common/SharedEvents';
import store from '@apply/adminStore';

export const AddReferralButton: React.FC = () => {
    const { user } = store.getState();
    const refreshEvents = new RefreshEvents();
    const [openReferralModal, set_openReferralModal] = useState(false);

    const _handleAddReferralSubmit = () => {
        refreshEvents.dispatchRefreshEvent();
        set_openReferralModal(false);
    };

    const _handleAddReferralCancel = () => {
        set_openReferralModal(false);
    };

    return (
        <>
            <Button
                id='addReferralButton'
                theme={ButtonTheme.Primary}
                width='200px'
                height='40px'
                handleClick={() => set_openReferralModal(true)}
                disabled={!user?.broker?.activated}
            >
                Add Referral
            </Button>
            <AddReferralModalV2
                isOpen={openReferralModal}
                submitCallback={_handleAddReferralSubmit}
                cancelCallback={_handleAddReferralCancel}
            />
        </>
    );
};
